// extracted by mini-css-extract-plugin
export var printerCard = "_a1-1";
export var printerCardConfigured = "_a1-2";
export var printerCardError = "_a1-3";
export var printerCardsContainer = "_a1-0";
export var printerIcon = "_a1-8";
export var printerIconConfigured = "_a1-5";
export var printerIconContainer = "_a1-4";
export var printerIconError = "_a1-6";
export var printerIconUnconfigured = "_a1-7";